// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  background-color: #263238;
}

.webgl {
  position: fixed;
  top: 0;
  left: 0;
  outline: none;
}

.section {
  padding-left: 10%;
  padding-right: 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  height: 100vh;
  position: relative;
}

h1 {
  font-size: 7vmin;
  color: #fff;
}

h2 {
  font-size: 4vmin;
  color: #fff;
}

.permission {
  display: none;
}

section:nth-child(even) {
  align-items: flex-end;
}

/* Portrait */
@media screen and (orientation:portrait) {
  section {
    align-items: center;
    justify-content: flex-start;
  }

  section:nth-child(even) {
    align-items: center;
  }

  h1 {
    font-size: 7vmin;
    color: #fff;
    margin-bottom: 40vh;
  }

  h2 {
    font-size: 4vmin;
    color: #fff;
    margin-bottom: 6vh;
  }

  .permissionDialog {
    position: fixed;
    z-index: 999;
    left: 50%;
    top: 50%;
    margin-left: -100px;
    margin-top: -75px;
    width: 200px;
    height: 150px;
    background-color: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(4px);
    color: #111;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.5);
  }

  .permissionDialog>.title {
    width: 90%;
    text-align: center;
    margin-top: 20px;
  }

  .permissionDialog>.buttonArea {
    margin-top: 16px;
    width: 90%;
    display: flex;
    justify-content: space-around;
  }

  .buttonArea>button {
    border: none;
    outline: none;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.3);
    background-color: #4375cc;
    border-radius: 12px;
    display: inline-block;
    cursor: pointer;
    color: #ffffff;
    font-family: Arial;
    font-size: 14px;
    padding: 8px 18px;
    text-decoration: none;
    text-shadow: 1px 0px 3px #283966;

    -webkit-tap-highlight-color: transparent;
  }

  .buttonArea>button:active {
    position: relative;
    top: 1px;
  }

  #cancel {
    background-color: #cdcdcd;
    text-shadow: 1px 0px 3px rgba(0, 0, 0, 0.4);
    box-shadow: 0px 0px 10px -4px rgba(0, 0, 0, 0.5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/21-scrollBasedAnimation/style.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,0CAA0C;IAC1C,0BAA0B;IAC1B,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,+CAA+C;IAC/C,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,gCAAgC;;IAEhC,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,2CAA2C;IAC3C,gDAAgD;EAClD;AACF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  background-color: #263238;\n}\n\n.webgl {\n  position: fixed;\n  top: 0;\n  left: 0;\n  outline: none;\n}\n\n.section {\n  padding-left: 10%;\n  padding-right: 10%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  /* align-items: center; */\n  height: 100vh;\n  position: relative;\n}\n\nh1 {\n  font-size: 7vmin;\n  color: #fff;\n}\n\nh2 {\n  font-size: 4vmin;\n  color: #fff;\n}\n\n.permission {\n  display: none;\n}\n\nsection:nth-child(even) {\n  align-items: flex-end;\n}\n\n/* Portrait */\n@media screen and (orientation:portrait) {\n  section {\n    align-items: center;\n    justify-content: flex-start;\n  }\n\n  section:nth-child(even) {\n    align-items: center;\n  }\n\n  h1 {\n    font-size: 7vmin;\n    color: #fff;\n    margin-bottom: 40vh;\n  }\n\n  h2 {\n    font-size: 4vmin;\n    color: #fff;\n    margin-bottom: 6vh;\n  }\n\n  .permissionDialog {\n    position: fixed;\n    z-index: 999;\n    left: 50%;\n    top: 50%;\n    margin-left: -100px;\n    margin-top: -75px;\n    width: 200px;\n    height: 150px;\n    background-color: rgba(255, 255, 255, 0.7);\n    backdrop-filter: blur(4px);\n    color: #111;\n    border-radius: 16px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.5);\n  }\n\n  .permissionDialog>.title {\n    width: 90%;\n    text-align: center;\n    margin-top: 20px;\n  }\n\n  .permissionDialog>.buttonArea {\n    margin-top: 16px;\n    width: 90%;\n    display: flex;\n    justify-content: space-around;\n  }\n\n  .buttonArea>button {\n    border: none;\n    outline: none;\n    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.3);\n    background-color: #4375cc;\n    border-radius: 12px;\n    display: inline-block;\n    cursor: pointer;\n    color: #ffffff;\n    font-family: Arial;\n    font-size: 14px;\n    padding: 8px 18px;\n    text-decoration: none;\n    text-shadow: 1px 0px 3px #283966;\n\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  .buttonArea>button:active {\n    position: relative;\n    top: 1px;\n  }\n\n  #cancel {\n    background-color: #cdcdcd;\n    text-shadow: 1px 0px 3px rgba(0, 0, 0, 0.4);\n    box-shadow: 0px 0px 10px -4px rgba(0, 0, 0, 0.5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
